import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import {
  ContentContainer as BaseContentContainer,
  ValueContainer,
  ListItemContainer as BaseListItemContainer,
} from '../StaticListItem/styles'

export const ListActionItem = styled(BaseListItemContainer)`
  &:hover {
    background: ${color.AQUA_OVERLAY};
    color: ${color.SCOOTER};
    cursor: pointer;

    & span,
    & p,
    & label {
      color: ${color.SCOOTER};
      cursor: pointer;
    }
  }
`

export const ContentContainer = styled(BaseContentContainer)`
  color: ${color.AQUAMARINE};
`

export const IconContainer = styled(ValueContainer)`
  color: ${color.AQUAMARINE};

  & span {
    margin: 0.625rem;

    &:hover {
      color: ${color.SCOOTER};
    }
  }
`
